import { useTranslation } from 'react-i18next';

import { ButtonVariants } from 'constants/common';
import { NameValueResult } from 'interfaces/shared.interface';
import { SubscriptionPlansResult } from 'interfaces/subscriptions-tenant.interface';
import { Button, Modal } from 'shared-components';

import SubscriptionFeature from './SubscriptionFeature';
import SubscriptionPlans from './SubscriptionPlans';

interface Props {
  isFree: boolean;
  displayName: string;
  handleCloseModal: VoidFunction;
  isModalOpen: boolean;
  featureValues: NameValueResult[];
  allFeaturesLookup?: Record<string, string>;
  isLoading: boolean;
  handleButtonClick: VoidFunction;
  isWarningModalOpen: boolean;
  isTrailSelectable: number | boolean | null;
  handleTrialButtonClick: VoidFunction;
  isLoadingEvent: boolean;
  subscriptionPlans: SubscriptionPlansResult[];
}

export const SubscriptionDetailModal = ({
  isFree,
  displayName,
  handleCloseModal,
  featureValues,
  isModalOpen,
  allFeaturesLookup,
  isLoading,
  handleButtonClick,
  isWarningModalOpen,
  isTrailSelectable,
  handleTrialButtonClick,
  isLoadingEvent,
  subscriptionPlans,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      heading={displayName}
      isOpen={isModalOpen}
      isDisableOutsideClick
      onClose={handleCloseModal}
      bodyClassName="!w-[23.75rem] flex justify-center items-center"
    >
      <div className="mx-[-20px] mb-5 mt-3">
        <SubscriptionPlans plans={subscriptionPlans} isLoading={isLoading} isFree={isFree} />
        {subscriptionPlans.some((plan) => plan.price) && (
          <div className="flex flex-row text-primary-500 px-5 mt-1 text-bodyMd mb-4">
            <p>*</p>
            {t('ExcludingVat')}
          </div>
        )}
      </div>
      <hr className="w-full border-t border-neutral-200 dark:border-neutral-800 !px-0 my-4" />
      <SubscriptionFeature
        featureValues={featureValues}
        allFeaturesLookup={allFeaturesLookup}
        isLoading={isLoading}
        headingClassName="!mb-2"
        bodyClassName="flex flex-col"
      />
      <div className="mt-2 mb-5">
        <Button className="w-full" onClick={handleButtonClick}>
          {t('Select')}
        </Button>
        {isTrailSelectable && (
          <Button
            dataCy="try-it-button"
            className="w-full mt-4"
            isLoading={isLoadingEvent}
            onClick={handleTrialButtonClick}
            variant={ButtonVariants.OUTLINE}
          >
            {t('TryIt')}
          </Button>
        )}
      </div>
      {isWarningModalOpen && <div className="opacity-25 fixed inset-0 z-40 bg-black" />}
    </Modal>
  );
};

export default SubscriptionDetailModal;
